<div class="pageheader">
  <div class="page-title">
    <h1>Tracking Search Details</h1>
    <div class="btn-group">
      <button class="btn btn-link" [disabled]="!selectedDocument" (click)="refresh()">
        {{documents?.length > 1 ? 'Refresh all' : 'Refresh'}} <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
      @if (documents && documents?.length > 1 && selectedDocument) {
        <button class="btn btn-link" (click)="refreshSelected()">
          Refresh selected
          <ep-svg-icon icon="repeat"></ep-svg-icon>
        </button>
      }
    </div>
  </div>
</div>
<div class="container container-fixed">
  <!-- toolbar mockup -->
  <div class="form-group btn-info-container" data-toggle="buttons" [hidden]="!documents || documents?.length < 2">
    @for (document of documents; track document) {
      <label class="btn btn-info-button" [class.active]="selectedDocument === document">
        <input type="radio" [value]="document" [ngModel]="selectedDocument" (ngModelChange)="setSelectedDocument($event)">
        <span class="id">
          {{ ($safeNavigationMigration(document?.DocumentId) === undefined || $safeNavigationMigration(document?.DocumentId) === null) ? 'I-' + document?.InterchangeIn?.InterchangesId : 'D-' + document?.DocumentId }}
          <button class="btn btn-sm pull-right" (click)="removeDocument(document)" title="Close document">X</button>
        </span>
        <span class="hr"></span>
        <span class="DocumentNumber">{{document?.DocumentNumber || ' '}}</span>
        <span class="PartnerIn">{{document?.PartnerIn?.PartnerName || ' '}}</span>
        <span class="PartnerOut">{{document?.PartnerOut?.PartnerName || ' '}}</span>
        <span class="DistributionObject">{{document?.DistributionObject?.Name || ' '}}</span>
        <ep-tracking-status [currentStatus]="$safeNavigationMigration(document?.LatestDocumentStatus?.StatusTypeName)"></ep-tracking-status>
      </label>
    }
  </div>
  <div class="btn-toolbar">
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_Resend'" [disabled]="!selectedDocument" (click)="resend()">
        Resend
      </button>
    </div>
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ManuallyHandle'" [disabled]="!selectedDocument" (click)="handleManually()">
        Manually Handle
      </button>
    </div>
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_OnHold'" [disabled]="!selectedDocument" (click)="setDocumentOnHold()">
        On Hold
      </button>
    </div>
    @if (selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Inbox' || selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Initializing' || selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Processing') {
      <div class="btn-group"
        >
        <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_CancelMessage'" [disabled]="!selectedDocument" (click)="cancelMessage()">Cancel Message</button>
      </div>
    }
    @if (selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Failed') {
      <div class="btn-group">
        <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ChangeStakeholder'" [disabled]="!selectedDocument" (click)="changeStakeholder()">
          Change Stakeholder
        </button>
      </div>
    }
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_DeleteDocument'" [disabled]="!selectedDocument" (click)="delete()">
        Delete
      </button>
    </div>
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ViewRawDocument'" [disabled]="!selectedDocument" (click)="viewRawDocument()">
        Show raw document details
      </button>
    </div>
    @if (this.selectedDocument?.DocumentId && selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Completed') {
      <div class="btn-group">
        <button class="btn btn-primary btn-sm" *bizPermissionRequired="'TestTool_Action_TestCase_Edit'" [disabled]="!selectedDocument" (click)="addToTestCase()">
          Add to test case
        </button>
      </div>
    }
    @for (trackingUiAction of trackingUiActions; track trackingUiAction) {
      <div class="btn-group">
        <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ExecuteILinkTrackingAction'" [disabled]="trackingUiActionStates[0].IsDisabled"
        [title]="trackingUiActionStates[0].Title" (click)="runTrackingUiAction(trackingUiAction)">{{trackingUiAction.Name}}</button>
      </div>
    }
  </div>
  <!-- end toolbar-->

  <section>
    <h2>Files</h2>
    <div class="gridview">
      <ep-tracking-file-info-row header="Interchange In" [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" [interchangeInId]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.InterchangesId)" fileType="InterchangeIn"
      [fileIdentifier]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.Filename)"></ep-tracking-file-info-row>
      <ep-tracking-file-info-row header="Message In" [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" fileType="MessageIn" [fileIdentifier]="$safeNavigationMigration(selectedDocument?.FileGuidIn)"></ep-tracking-file-info-row>
      <ep-tracking-file-info-row header="CDM" [stylesheetIdentifier]="$safeNavigationMigration(selectedDocument?.DistributionObject?.CdmStylesheetArtifactId)"
        [showAttachmentButton]="$safeNavigationMigration(selectedDocument?.DistributionObject?.CdmEmbeddedFileDataXPath)" [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" fileType="MessageCdm"
      [fileIdentifier]="$safeNavigationMigration(selectedDocument?.FileGuidCdm)"></ep-tracking-file-info-row>
      <ep-tracking-file-info-row header="Interchange Out" [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" fileType="InterchangeOut"
      [fileIdentifier]="$safeNavigationMigration(selectedDocument?.InterchangeOut?.Filename)"></ep-tracking-file-info-row>
    </div>

  </section>

  <br class="xs-20" />

  @if (loadingStatusTypes && selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Failed') {
    <p>
      <img src="../../images/ajax-loader.gif" alt="Logging in" /> <span class="label failed">Loading error info</span>
    </p>
  }

  <!-- If document (or interchange) is in status Failed present the latest ExceptionInstance (if any) as the "current error" -->
  @if (selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Failed' && exceptionInstances?.length > 0) {
    <ep-tracking-error-box
      [exceptionInstance]="exceptionInstances[exceptionInstances.length - 1]" errorType="error" />
  }

  <!-- If document (or interchange) is in status Failed group trailing ExceptionInstances (if any) in collapsable group "Additional error logs" -->
  @if (selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Failed' && exceptionInstances?.length > 1) {
    <app-collapsible-group>
      <h2 title>Additional error logs ({{exceptionInstances.length - 1}})</h2>
      @for (error of exceptionInstances; track error; let i = $index) {
        <section>
          @if (i < exceptionInstances.length - 1) {
            <ep-tracking-error-box [exceptionInstance]="error" errorType="warning" />
          }
        </section>
      }
    </app-collapsible-group>
  }

  <!-- If document (or interchange) is not in status Failed group ExceptionInstances (if any) in collapsable group "Error logs" -->
  @if (selectedDocument?.LatestDocumentStatus?.StatusTypeName !== 'Failed' && exceptionInstances?.length > 0) {
    <app-collapsible-group>
      <h2 title>Error logs ({{exceptionInstances.length}})</h2>
      @for (error of exceptionInstances; track error) {
        <section>
          <ep-tracking-error-box [exceptionInstance]="error" errorType="warning" />
        </section>
      }
    </app-collapsible-group>
  }

  <section *bizPermissionRequired="'Tracking_Action_ViewAndDownloadAdditionalBackupFiles'">
    <app-collapsible-group>
      <h2 title>Additional Files ({{additionalFilesCount}})</h2>
      <div>
        <h4>Files for ingoing interchange</h4>
        <div class="gridview">
          @for (additionalFile of selectedDocument?.InterchangeIn?.AdditionalBackupFiles; track additionalFile; let i = $index) {
            @if (i < visibleInterchangeInAdditionalFileCount) {
              <ep-tracking-file-info-row [tooltip]="additionalFile.Note" [header]="additionalFile.Type"
                [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" [interchangeInId]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.InterchangesId)" fileType="AdditionalFiles"
              [fileIdentifier]="additionalFile.FileGuid"></ep-tracking-file-info-row>
            }
          }
          @if (selectedDocument?.InterchangeIn?.AdditionalBackupFiles?.length > visibleInterchangeInAdditionalFileCount) {
            <button class="btn btn-link"
              (click)="visibleInterchangeInAdditionalFileCount = visibleInterchangeInAdditionalFileCount + additionalFilePageSize">Show more (showing
              {{visibleInterchangeInAdditionalFileCount}} of {{selectedDocument?.InterchangeIn?.AdditionalBackupFiles?.length}}) <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            }
            @if (!selectedDocument?.InterchangeIn?.AdditionalBackupFiles?.length) {
              <div>
                <i>No files</i>
              </div>
            }
          </div>

          <h4>Files for document</h4>
          <div class="gridview">
            @for (additionalFile of selectedDocument?.AdditionalBackupFiles; track additionalFile; let i = $index) {
              @if (i < visibleDocumentAdditionalFileCount) {
                <ep-tracking-file-info-row [tooltip]="additionalFile.Note" [header]="additionalFile.Type"
                  [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" [interchangeInId]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.InterchangesId)" fileType="AdditionalFiles"
                [fileIdentifier]="additionalFile.FileGuid"></ep-tracking-file-info-row>
              }
            }
            @if (selectedDocument?.AdditionalBackupFiles?.length > visibleDocumentAdditionalFileCount) {
              <button class="btn btn-link"
                (click)="visibleDocumentAdditionalFileCount = visibleDocumentAdditionalFileCount + additionalFilePageSize">Show more (showing {{visibleDocumentAdditionalFileCount}} of
                {{selectedDocument?.AdditionalBackupFiles?.length}}) <ep-svg-icon icon="repeat"></ep-svg-icon></button>
              }
              @if (!selectedDocument?.AdditionalBackupFiles?.length) {
                <div>
                  <i>No files</i>
                </div>
              }
            </div>

            <h4>Files for outgoing interchange</h4>
            <div class="gridview">
              @for (additionalFile of selectedDocument?.InterchangeOut?.AdditionalBackupFiles; track additionalFile; let i = $index) {
                @if (i < visibleInterchangeOutAdditionalFileCount) {
                  <ep-tracking-file-info-row [tooltip]="additionalFile.Note" [header]="additionalFile.Type"
                    [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)" [interchangeInId]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.InterchangesId)" fileType="AdditionalFiles"
                  [fileIdentifier]="additionalFile.FileGuid"></ep-tracking-file-info-row>
                }
              }
              @if (selectedDocument?.InterchangeOut?.AdditionalBackupFiles?.length > visibleInterchangeOutAdditionalFileCount) {
                <button class="btn btn-link"
                  (click)="visibleInterchangeOutAdditionalFileCount = visibleInterchangeOutAdditionalFileCount + additionalFilePageSize">Show more (showing
                  {{visibleInterchangeOutAdditionalFileCount}} of {{selectedDocument?.InterchangeOut?.AdditionalBackupFiles?.length}}) <ep-svg-icon icon="repeat"></ep-svg-icon></button>
                }
                @if (!selectedDocument?.InterchangeOut?.AdditionalBackupFiles?.length) {
                  <div>
                    <i>No files</i>
                  </div>
                }
              </div>
            </div>
          </app-collapsible-group>

          @if (relatedMessagesCount) {
            <app-collapsible-group>
              <h2 title>Related messages ({{relatedMessagesCount}})</h2>
              <div class="gridview">
                @for (relation of getMessageRelations(); track relation) {
                  <app-tracking-message-relations-row [messageRelationTypes]="messageRelationTypes" [document]="selectedDocument"
                  [messageRelation]="relation" (openDocument)="addDocument($event)" (openInterchange)="addInterchange($event)"></app-tracking-message-relations-row>
                }
              </div>
            </app-collapsible-group>
          }

        </section>

        <!-- Document row -->

        <div class="flex-row">
          <div class="item item-4 extra-padding">
            <h2>Document</h2>
            <dl class="nm">
              <dt>Document Type</dt>
              <dd>{{selectedDocument?.DistributionObject?.Name}}</dd>

              <dt>Created Date</dt>
              <dd>{{$safeNavigationMigration(selectedDocument?.CreatedDate) | date:'yyyy-MM-dd HH:mm:ss.SSS'}}</dd>

              <dt>Document Number</dt>
              <dd>{{selectedDocument?.DocumentNumber}}</dd>

              <dt>Last Status</dt>
              <dd><ep-tracking-status [currentStatus]="$safeNavigationMigration(selectedDocument?.LatestDocumentStatus?.StatusTypeName)"></ep-tracking-status></dd>

              <dt>Init Configuration</dt>
              <dd>
                @if (hasSelectedDocumentInitConfigValues()) {
                  <button class="btn btn-link pl-0" (click)="onShowInitConfig()">View <ep-svg-icon icon="eye"/></button>
                }
                @else {
                <span>Not available</span>
              }
            </dd>

            <dt>Context properties for Interchange</dt>
            <dd>
              @if(selectedDocument?.InterchangeIn?.ContextProperties) {
                <ep-content-shower [content]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.ContextProperties)" contentType="text/xml"></ep-content-shower>
              }
              @else {
              <span>Not available</span>
            }
          </dd>

          <dt>Context properties for Message</dt>
          <dd>
            @if(selectedDocument?.ContextProperties) {
              <ep-content-shower [content]="$safeNavigationMigration(selectedDocument?.ContextProperties)" contentType="text/xml"></ep-content-shower>
            }
            @else {
            <span>Not available</span>
          }
        </dd>

        <dt>Document Id</dt>
        <dd>{{selectedDocument?.DocumentId}}</dd>

        <dt>Document Guid</dt>
        <dd>{{selectedDocument?.DocumentGuid}}</dd>

        <dt>Distribution Id</dt>
        <dd>{{selectedDocument?.DistributionsId}}
          @if (showDistributionAllowed && selectedDocument?.DistributionsId) {
            <ep-link linkUrl="/distribution/result/details" [linkParms]="{ distributionIds: [$safeNavigationMigration(selectedDocument?.DistributionsId)] }">Go to distribution</ep-link>
          }
        </dd>

        <dt>Originating Id</dt>
        <dd>{{selectedDocument?.OriginatingId}}</dd>
      </dl>
    </div>

    <div class="item item-8">
      <div class="flex-row">
        <div class="item">
          <h2>Ingoing</h2>
          <dl class="no-border nm">
            <dt>Partner</dt>
            <dd>
              @if (showPartnerAllowed) {
                <ep-link linkUrl="/partner/details" [linkParms]="{ partnerIds: [$safeNavigationMigration(selectedDocument?.PartnerIn?.PartnersId)] }">{{selectedDocument?.PartnerIn?.PartnerName}}</ep-link>
              }
              @else {
              {{selectedDocument?.PartnerIn?.PartnerName}}
            }
          </dd>

          <dt>Partner System</dt>
          <dd>{{selectedDocument?.InterchangeIn?.PartnerSystem?.Name}}</dd>

          <dt>Interchange Number</dt>
          <dd>{{selectedDocument?.InterchangeIn?.InterchangeNumber}}</dd>

          <dt>Format/Variant/Version</dt>
          <dd>
            {{selectedDocument?.FormatIn?.FormatName}} / {{selectedDocument?.VariantIn?.VariantName}} /
            {{selectedDocument?.VariantVersionIn?.VariantVersionName}} @if (showDocumentConfigInLinks) {
            <ep-document-config-links distributionDirection="In"
            [distributionId]="$safeNavigationMigration(selectedDocument?.DistributionsId)"></ep-document-config-links>
          }
        </dd>

        <dt>Address</dt>
        <dd style="word-break: break-all;">{{selectedDocument?.InterchangeIn?.DisplayAddress}}</dd>

        <dt>Port Name</dt>
        <dd>{{selectedDocument?.InterchangeIn?.PortName}}</dd>

        <dt>Interchange Id</dt>
        <dd>{{selectedDocument?.InterchangeIn?.InterchangesId}}</dd>

        <dt>Transmission Id</dt>
        <dd>
          <ep-link linkUrl="/tracking/result"
          [linkParms]="{ transmissionId: [$safeNavigationMigration(selectedDocument?.InterchangeIn?.TransmissionId)] }">{{selectedDocument?.InterchangeIn?.TransmissionId}}</ep-link>
        </dd>

        <dt>Interchange Log file</dt>
        <dd>
          <ep-backup-file-downloader [fileIdentifier]="getIngoingInterchangeLogFileIdentifier()" fileType="TransportLog"></ep-backup-file-downloader>
          @if (getIngoingInterchangeLogFileIdentifier()) {
            <ep-tracking-document-shower [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)"
              [interchangeInId]="$safeNavigationMigration(selectedDocument?.InterchangeIn?.InterchangesId)" [fileIdentifier]="getIngoingInterchangeLogFileIdentifier()"
            fileType="TransportLog"></ep-tracking-document-shower>
          }
        </dd>

        <dt>Message Number</dt>
        <dd>{{selectedDocument?.MessageNumberIn}}</dd>

        <dt>Originating Id</dt>
        <dd>{{selectedDocument?.InterchangeIn?.OriginatingId}}</dd>
      </dl>

    </div>
    <div class="item">
      <h2>Outgoing</h2>
      <dl class="no-border nm">
        <dt>Partner</dt>
        <dd>
          @if (showPartnerAllowed) {
            <ep-link linkUrl="/partner/details" [linkParms]="{ partnerIds: [$safeNavigationMigration(selectedDocument?.PartnerOut?.PartnersId)] }">{{selectedDocument?.PartnerOut?.PartnerName}}</ep-link>
          }
          @else {
          {{selectedDocument?.PartnerOut?.PartnerName}}
        }
      </dd>

      <dt>Partner System</dt>
      <dd>{{selectedDocument?.InterchangeOut?.PartnerSystem?.Name}}</dd>

      <dt>Interchange Number</dt>
      <dd>{{selectedDocument?.InterchangeOut?.InterchangeNumber}}</dd>

      <dt>Format/Variant/Version</dt>
      <dd>
        {{selectedDocument?.FormatOut?.FormatName}} / {{selectedDocument?.VariantOut?.VariantName}} /
        {{selectedDocument?.VariantVersionOut?.VariantVersionName}} @if (showDocumentConfigOutLinks) {
        <ep-document-config-links distributionDirection="Out"
        [distributionId]="$safeNavigationMigration(selectedDocument?.DistributionsId)"></ep-document-config-links>
      }
    </dd>

    <dt>Address</dt>
    <dd style="word-break: break-all;">{{selectedDocument?.InterchangeOut?.DisplayAddress}}</dd>

    <dt>Port Name</dt>
    <dd>{{selectedDocument?.InterchangeOut?.PortName}}</dd>

    <dt>Interchange Id</dt>
    <dd>{{selectedDocument?.InterchangeOut?.InterchangesId}}</dd>

    <dt>Transmission Id</dt>
    <dd>
      <ep-link linkUrl="/tracking/result"
      [linkParms]="{ transmissionId: [$safeNavigationMigration(selectedDocument?.InterchangeOut?.TransmissionId)] }">{{selectedDocument?.InterchangeOut?.TransmissionId}}</ep-link>
    </dd>

    <dt>Interchange Log file</dt>
    <dd>
      <ep-backup-file-downloader [fileIdentifier]="getOutgoingInterchangeLogFileIdentifier()" fileType="TransportLog"></ep-backup-file-downloader>
      @if (getOutgoingInterchangeLogFileIdentifier()) {
        <ep-tracking-document-shower [documentId]="$safeNavigationMigration(selectedDocument?.DocumentId)"
        [fileIdentifier]="getOutgoingInterchangeLogFileIdentifier()" fileType="TransportLog"></ep-tracking-document-shower>
      }
    </dd>

    <dt>Message Number</dt>
    <dd>{{selectedDocument?.MessageNumberOut}}</dd>
  </dl>
</div>
</div>
</div>




</div>

<section *bizPermissionRequired="'Batching_View_Info'">
  @if (selectedDocument?.LatestDocumentStatus?.StatusTypeName === 'Batching') {
    <div>
      <h2>Batching information</h2>
      <dl class="no-border nm">
        <dt>Batching key</dt>
        <dd>{{batchInfo?.BatchingKey}}</dd>
        <dt>Number of documents waiting</dt>
        <dd>{{batchInfo?.DocumentCount}}</dd>
        <dt>First document received</dt>
        <dd>{{batchInfo?.FirstDocumentDateTime}}</dd>
        <dt>Latest document received</dt>
        <dd>{{batchInfo?.LastDocumentDateTime}}</dd>
      </dl>
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Batching_Action_Release'" [disabled]="!batchInfo" (click)="onReleaseBatch()">
        Manually release batch
      </button>
    </div>
  }
</section>

<h2>Tracking fields</h2>
@if (selectedDocument) {
  <div>
    @if (!selectedDocument['trackingFieldGroups']) {
      <span>
        <button class="btn btn-link" (click)="findTrackingFields()">
          Load tracking fields <ep-svg-icon icon="repeat"></ep-svg-icon>
        </button>
      </span>
    }
    @if (selectedDocument['trackingFieldGroups']?.length === 0) {
      <span>No tracking fields</span>
    }
    <ep-datafield-group-container #trackingFieldContainer [datafieldGroups]="selectedDocument['trackingFieldGroups']" [isAlwaysEditable]="false"
    [numberOfColumns]="4"></ep-datafield-group-container>
  </div>
}

</div> <!-- end fixed container -->
<!-- ToDo: showLog var removed  - remove from TS -->
<section class="mb50">
  <h2>Status Flow</h2>
  <div class="form-group control control-checkbox">
    <label>
      Include technical status types<input type="checkbox" [(ngModel)]="showTechnicalStatus" (ngModelChange)="showHideTechnicalStatus(showTechnicalStatus)" /><i></i>
    </label>
  </div>
  <dx-data-grid biz-grid exportFileName="Document Status" [showIsLoading]="loadingStatusTypes" [dataSource]="selectedStatusTypes" [sorting]="{ mode: 'multiple' }">
    <dxi-column caption="Created" dataField="CreatedDate" dataType="date" [format]="dateTimeService.getDevExpressDateTimeWithMsFunction"></dxi-column>
    <dxi-column caption="Stage" dataType="string" cellTemplate="logStage"></dxi-column>
    <dxi-column caption="Status" dataField="StatusTypeName" dataType="string"></dxi-column>
    <dxi-column caption="Source" dataField="Source" dataType="string"></dxi-column>
    <dxi-column caption="Machine name" dataField="MachineName" dataType="string" [visible]="false"></dxi-column>
    <dxi-column caption="Comment" dataField="Comment" dataType="string" cellTemplate="commentTemplate"></dxi-column>

    <div *dxTemplate="let status of 'logStage'">
      {{status.data.DocumentId > 0 ? 'Document' : 'Interchange'}}
    </div>

    <div *dxTemplate="let status of 'commentTemplate'">
      @if (status.data.resendDocumentId) {
        <div title="{{status.data.Comment}}">
          <button class="btn btn-link np" (click)="addDocument(status.data.resendDocumentId)">(Show document)</button> {{status.data.Comment}}
        </div>
      }
      @if (!status.data.resendDocumentId) {
        <div title="{{status.data.Comment}}">
          {{status.data.Comment}}
        </div>
      }
    </div>
  </dx-data-grid>

  @if(showStatusEvent){
    <h2>Status Events</h2>
    @if(selectedDocument){
      <div>
        @if(!statusEvents){
          <span>
            <button class="btn btn-link" (click)="findStatusEvents()">
              Load status events<ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
          </span>
        }
        @else if(statusEvents?.length === 0) {
        <span>No status events</span>
      }
      @else if (statusEvents?.length > 0){
      <app-status-events-master-grid [dataSourceItems]="statusEvents" [hideShowDocumentsButton]="true" (onRefreshEvent)="findStatusEvents()"></app-status-events-master-grid>
    }
  </div>
}
}
</section>
